export const ENUMS_BY_RULE_NAME = {
  flexDirection: ['row', 'column', 'row-reverse', 'column-reverse'],
  justifyContent: [
    'flex-start',
    'center',
    'flex-end',
    'space-between',
    'space-around',
    'space-evenly',
  ],
  alignItems: ['flex-start', 'center', 'flex-end', 'stretch', 'baseline'],
  alignContent: ['flex-start', 'center', 'flex-end', 'stretch', 'space-between', 'space-around'],
  alignSelf: ['auto', 'flex-start', 'center', 'flex-end', 'stretch', 'baseline'],
  flexWrap: ['nowrap', 'wrap', 'wrap-reverse'],
  textAlign: ['left', 'center', 'right'],
  backgroundPosition: [
    'center center',
    'center left',
    'center right',
    'top center',
    'top left',
    'top right',
    'bottom center',
    'bottom left',
    'bottom right',
  ],
  backgroundRepeat: ['no-repeat', 'repeat'],
  backgroundSize: ['cover', 'auto', 'contain'],
  objectFit: ['cover', 'contain', 'fill', 'none', 'scale-down'],
  objectPosition: [
    'center center',
    'center left',
    'center right',
    'top center',
    'top left',
    'top right',
    'bottom center',
    'bottom left',
    'bottom right',
  ],
};

export const SIZE_RULES = [
  'margin',
  'padding',
  (name) => !['backgroundsize'].includes(name) && name.toLowerCase().includes('size'),
  'borderRadius',
  'height',
];
export const COLOR_RULES = ['color', (name) => name === 'background'];
